import { KWireInputProps } from './KWireTypes'
import { useState } from 'react'

export const KWireInputLogic = ({ items, onAddItem }: KWireInputProps) => {
  const [selectedValue, setSelectedValue] = useState<string>('')
  const [count, setCount] = useState<number>(1)

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedValue(event.target.value)
    setCount(1)
  }

  const getMaxCount = (): number => {
    if (!selectedValue) return 1
    const selectedItem = items.find((item) => item.value === selectedValue)
    return selectedItem?.count || 1
  }

  const handleCountChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newCount = parseInt(event.target.value, 10)
    const maxCount = getMaxCount()
    setCount(isNaN(newCount) ? 1 : Math.max(1, Math.min(newCount, maxCount)))
  }

  const incrementCount = () => {
    const maxCount = getMaxCount()
    setCount((prevCount) => Math.min(prevCount + 1, maxCount))
  }

  const decrementCount = () => {
    setCount((prevCount) => Math.max(1, prevCount - 1))
  }

  const handleAddClick = () => {
    if (selectedValue) {
      onAddItem(selectedValue, count)
      setSelectedValue('')
      setCount(1)
    }
  }

  return {
    selectedValue,
    count,
    handleSelectChange,
    handleCountChange,
    incrementCount,
    decrementCount,
    handleAddClick,
    getMaxCount,
  }
}
